// Demo booking config. Set CALENDLY_URL to the lab's Calendly event link
// (e.g. "https://calendly.com/toothrocket/30min") to enable the embedded
// booking popup. While empty, "Book a demo" buttons fall back to the
// contact form with the lab-demo subject.
export const CALENDLY_URL = "https://calendly.com/ceo-toothrocket";
